module.exports = __webpack_public_path__ + "img/NorthDash_TitleAsano.34619f4c.png";